
export default {
  'VALUE_ID': {
    title: '卖场编码',
    type: 'input',
    width: 120
  },
  'VALUE_KT': {
    title: '卖场名称',
    type: 'input',
    width: 'auto'
  },
  'HIERARCHY': {
    title: '卖场简称',
    type: 'input',
    width: 180
  }
}



// WEBPACK FOOTER //
// ./src/components/dialog/config/Market.js